(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-seller-wall-art"] && !window.DesignMode) return;
  try {
    
  /*--------------------
  Vars
  --------------------*/
  let progress = 50
  let startX = 0
  let active = 0
  let isDown = false
  
  /*--------------------
  Contants
  --------------------*/
  const speedWheel = 0.02
  const speedDrag = -0.1
  
  /*--------------------
  Get Z
  --------------------*/
  const getZindex = (array, index) => (array.map((_, i) => (index === i) ? array.length : array.length - Math.abs(index - i)))
  
  /*--------------------
  Items
  --------------------*/
  const $items = document.querySelectorAll('.carousel-item')
  const $cursors = document.querySelectorAll('.cursor')
  
  const displayItems = (item, index, active) => {
    const zIndex = getZindex([...$items], active)[index]
    item.style.setProperty('--zIndex', zIndex)
    item.style.setProperty('--active', (index-active)/$items.length)
  }

  /*--------------------
  Animate
  --------------------*/
  const animate = () => {
    progress = Math.max(0, Math.min(progress, 100))
    active = Math.floor(progress/100*($items.length-1))
    
    $items.forEach((item, index) => displayItems(item, index, active))
  }
  animate()
  
  /*--------------------
  Click on Items
  --------------------*/
  $items.forEach((item, i) => {
    item.addEventListener('click', () => {
      progress = (i/$items.length) * 100 + 10
      animate()
    })
  })
  
  const handleMouseMove = (e) => {
    if (e.type === 'mousemove') {
      $cursors.forEach(($cursor) => {
        $cursor.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`
      })
    }
    if (!isDown) return
    const x = e.clientX || (e.touches && e.touches[0].clientX) || 0
    const mouseProgress = (x - startX) * speedDrag
    progress = progress + mouseProgress
    startX = x
    animate()
  }
  
  const handleMouseDown = e => {
    isDown = true
    startX = e.clientX || (e.touches && e.touches[0].clientX) || 0
  }
  
  const handleMouseUp = () => {
    isDown = false
  }
  
  /*--------------------
  Listeners
  --------------------*/
  document.addEventListener('mousedown', handleMouseDown)
  document.addEventListener('mousemove', handleMouseMove)
  document.addEventListener('mouseup', handleMouseUp)
  document.addEventListener('touchstart', handleMouseDown)
  document.addEventListener('touchmove', handleMouseMove)
  document.addEventListener('touchend', handleMouseUp)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gaming-pc-spec-table"] && !window.DesignMode) return;
  try {
    

  document.querySelectorAll(".template-link").forEach(function(link) {
      link.addEventListener("click", function(event) {
          event.preventDefault(); // Prevent actual link navigation
          
          const templateIndex = event.target.getAttribute("data-template");
          let valueToDisplay = "";
  
          // Based on your Shopify Liquid syntax:
          switch(templateIndex) {
              case "0":
                  valueToDisplay = "{{ product.variants.[0].metafields.custom.pc_os }}";
                  break;
              case "1":
                  valueToDisplay = "{{ product.variants.[1].metafields.custom.pc_os }}";
                  break;
              // ... (add cases for other indices as needed)
          }
  
          document.getElementById("displayValue").innerText = valueToDisplay;
      });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["led-frame-presentation"] && !window.DesignMode) return;
  try {
    
jQuery(document).ready(function($) {
  $('.led-frame-option').click(function() {
    $('#wood-option-head, #black-option-head, #white-option-head, #wood-frame-price, #colored-frame-price').hide();
    $('#wood-frame, #black-frame, #white-frame').hide();

    var option = $(this).attr('id');
    if (option === 'wood-option') {
      $('#wood-option-head').fadeIn(500);
      $('#wood-frame').fadeIn(500).css('display', 'flex'); // Apply display flex here
      $('#wood-frame-price').css('display', 'block');       // Apply display flex here
    } else if (option === 'black-option') {
      $('#black-option-head').fadeIn(500);
      $('#black-frame').fadeIn(500).css('display', 'flex'); // Apply display flex here
      $('#colored-frame-price').css('display', 'block');     // Apply display flex here
    } else if (option === 'white-option') {
      $('#white-option-head').fadeIn(500);
      $('#white-frame').fadeIn(500).css('display', 'flex'); // Apply display flex here
      $('#colored-frame-price').css('display', 'block');     // Apply display flex here
    }
  });
});


  const textCircle = document.querySelector(".led-frame-circle-text");
  textCircle.innerHTML = textCircle.innerText
  	.split("")
  	.map(
  		(char, i) => `<span style="transform:rotate(${i * 8.8}deg)">${char}</span>`
  	)
  	.join("");

  const frameImages = {
    1: 'https://cdn.shopify.com/s/files/1/0748/6328/0446/files/v1techrgbframes00.jpg',
    2: 'https://cdn.shopify.com/s/files/1/0748/6328/0446/files/v1techrgbframes07.jpg',
    3: 'https://cdn.shopify.com/s/files/1/0748/6328/0446/files/v1techrgbframes14.jpg',
    4: 'https://cdn.shopify.com/s/files/1/0748/6328/0446/files/v1techrgbframes21.jpg',
    5: 'https://cdn.shopify.com/s/files/1/0748/6328/0446/files/v1techrgbframes28.jpg',
    6: 'https://cdn.shopify.com/s/files/1/0748/6328/0446/files/v1techrgbframes35.jpg',
    7: 'https://cdn.shopify.com/s/files/1/0748/6328/0446/files/v1techrgbframes42.jpg',
    8: 'https://cdn.shopify.com/s/files/1/0748/6328/0446/files/v1techrgbframes42.jpg',
    9: 'https://cdn.shopify.com/s/files/1/0748/6328/0446/files/v1techrgbframes42.jpg',
    10: 'https://cdn.shopify.com/s/files/1/0748/6328/0446/files/v1techrgbframes42.jpg',
    11: 'https://cdn.shopify.com/s/files/1/0748/6328/0446/files/v1techrgbframes35.jpg',
    12: 'https://cdn.shopify.com/s/files/1/0748/6328/0446/files/v1techrgbframes28.jpg',
    13: 'https://cdn.shopify.com/s/files/1/0748/6328/0446/files/v1techrgbframes21.jpg',
    14: 'https://cdn.shopify.com/s/files/1/0748/6328/0446/files/v1techrgbframes14.jpg',
    15: 'https://cdn.shopify.com/s/files/1/0748/6328/0446/files/v1techrgbframes07.jpg',
    16: 'https://cdn.shopify.com/s/files/1/0748/6328/0446/files/v1techrgbframes00.jpg',
  }

  const textStyle = {
    1: {opacity: 0, transform: '0px'},
    2: {opacity: .1, transform: '0px'},
    3: {opacity: .15, transform: '0px'},
    4: {opacity: .25, transform: '15px'},
    5: {opacity: .35, transform: '10px'},
    6: {opacity: 55, transform: '5px'},
    7: {opacity: 75, transform: '0px'},
    8: {opacity: 1, transform: '0px'},
    9: {opacity: 1, transform: '0px'},
    10: {opacity: 1, transform: '0px'},
    11: {opacity: 1, transform: '0px'},
    12: {opacity: 1, transform: '0px'},
    13: {opacity: 0, transform: '0px'},
    14: {opacity: 0, transform: '0px'},
    15: {opacity: 0, transform: '0px'},
    16: {opacity: 0, transform: '0px'},
  }

  const step = 30;
  
  function trackScrollPosition() {
    const y = window.scrollY;
    const label = Math.min(Math.floor(y/30) + 1, 16);
    const imageToUse = frameImages[label];
    $('.led-frame-scroll-animation-image').css('background-image', `url('${imageToUse}')`);

    const textStep = 1;
    const textStyleToUseLine1 = textStyle[label];
    const textStyleToUseLine2 = textStyle[Math.min(Math.max(label - textStep, 1), 16)];
    const textStyleToUseLine3 = textStyle[Math.min(Math.max(label - textStep * 2, 1),16)];
    $('#line1').css({'opacity': textStyleToUseLine1.opacity, 'transform': `translateY(${textStyleToUseLine1.transform})`});
    $('#line2').css({'opacity': textStyleToUseLine2.opacity, 'transform': `translateY(${textStyleToUseLine2.transform})`});
    $('#line3').css({'opacity': textStyleToUseLine3.opacity, 'transform': `translateY(${textStyleToUseLine3.transform})`});
  }
  
  $(document).ready(()=>{
    $(window).scroll(()=>{
      trackScrollPosition();
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-home-banner-wide"] && !window.DesignMode) return;
  try {
    
  'use strict';(
    function () {
      let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop
      let carousel = document.querySelector('.home-banner-wide-top-cards')
      let cards = document.querySelectorAll('.home-banner-wide-top-card')
      let c1 = document.querySelector('.c1')
      let c2 = document.querySelector('.c2')
      let c3 = document.querySelector('.c3')
      let mouse = document.querySelector('.home-banner-mouse')
      let status = 0
      let moving = false
  
      function clickCard() {
          if (!moving) {
              moving = true
              status++
              changeCard(status)
          }
      }
      function changeCard(status) {
          if (status % 3 === 0) {
              cards.forEach((card) => {
                  card.classList.remove('move')
                  card.classList.remove('stage')
                  card.classList.add('active')
              })
              hideCard()
          }
          if (status % 3 === 1) {
              c3.classList.add('move')
              c2.classList.add('stage')
              hideCard(c3)
          }
          if (status % 3 === 2) {
              c2.classList.add('move')
              c1.classList.add('stage')
              hideCard(c2)
          }
      }
      function hideCard(el) {
          if (el) {
              setTimeout(() => {
                  el.classList.remove('active')
                  el.classList.remove('move')
                  el.classList.remove('stage')
              }, 500)
          }
          setTimeout(() => {
              moving = false
          }, 700)
      }
      function cardEnter() {
          mouse.classList.add('hover')
      }
      function cardLeave() {
          mouse.classList.remove('hover')
      }
      function init() {
          window.addEventListener('scroll', function () {
              scrollTop =
                  window.pageYOffset ||
                  document.documentElement.scrollTop ||
                  document.body.scrollTop
          })
          window.addEventListener('mousemove', function (e) {
              mouse.style.top = e.y + scrollTop + 'px'
              mouse.style.left = e.x + 'px'
          })
          carousel.addEventListener('click', clickCard)
          carousel.addEventListener('mouseenter', cardEnter)
          carousel.addEventListener('mouseleave', cardLeave)
          setTimeout(() => {
              cards.forEach((card) => card.classList.add('active'))
          }, 500)
      }
      init()
  })()
  
  function Parallax(options){
      options = options || {};
      this.nameSpaces = {
          wrapper: options.wrapper || '.parallax',
          layers: options.layers || '.parallax-layer',
          deep: options.deep || 'data-parallax-deep'
      };
      this.init = function() {
          var self = this,
              parallaxWrappers = document.querySelectorAll(this.nameSpaces.wrapper);
        	for(var i = 0; i < parallaxWrappers.length; i++){
  			(function(i){
  				parallaxWrappers[i].addEventListener('mousemove', function(e){
  					var x = e.clientX,
  						y = e.clientY,
  						layers = parallaxWrappers[i].querySelectorAll(self.nameSpaces.layers);
  					for(var j = 0; j < layers.length; j++){
              (function(j){
                var deep = layers[j].getAttribute(self.nameSpaces.deep),
                    disallow = layers[j].getAttribute('data-parallax-disallow'),
                    itemX = (disallow && disallow === 'x') ? 0 : x / deep,
                    itemY = (disallow && disallow === 'y') ? 0 : y / deep;
                    if(disallow && disallow === 'both') return;
                    layers[j].style.transform = 'translateX(' + itemX + '%) translateY(' + itemY + '%)';
              })(j);  
  					}
  				})
  			})(i);
        	}
      };
      this.init();
      return this;
  }
  
  window.addEventListener('load', function(){
      new Parallax();
  });

  /*abc*/

  let img_width = document.querySelector('.main-wide-slider').clientWidth;
  const imgs_container = document.querySelector('.slider__img-container');
  const imgs = document.querySelectorAll('.main-wide-slide');
  const total_imgs = imgs.length;
  
  const arrow_dot_container = document.querySelector('.slider__arrow-nav-container');
  
  const dots_container = document.querySelector('.dot-container');
  const prev_btn = document.querySelector('.arrow--prev');
  const next_btn = document.querySelector('.arrow--next');
  
  // const slide_seconds = 10000;
  let current_index = 1;
  let last_index;
  let move_distance;
  let timer;
  
  let mouse_is_down = false;
  let mouse_position_x = [0, 0];
  
  function calculateNextDistance() {
    move_distance = -(current_index * img_width);
    last_index = current_index;

    if (current_index == total_imgs) {
      current_index = 1;
      move_distance = 0;
    } else {
      current_index++;
    }
  
    slideImages();
  }
  
  function calculatePrevDistance() {
    if (current_index > 1) {
      last_index = current_index;
      current_index--;
      move_distance = move_distance + img_width;
    } else {
      last_index = current_index;
      current_index = total_imgs;
      move_distance = -((total_imgs - 1) * img_width);
    }
  
    slideImages();
  }
  
  function slideImages(drag_distance) {
    // clearInterval(timer);

    const distance = drag_distance || move_distance;
  
    imgs_container.style.transform = `translateX(${distance}px)`;
    document.querySelector(`#dot-${last_index}`).classList.remove('is-active');
    document.querySelector(`#dot-${current_index}`).classList.add('is-active');
  
    // timer = setInterval(calculateNextDistance, slide_seconds);

  }
  
  function slideDotImages(e) {
    const dots = this.querySelectorAll('.dot');

    for (var i = 1; i <= dots.length; i++) {
      if (e.target.id == `dot-${i}`) {
        last_index = current_index;
        current_index = i;
        move_distance = -((current_index - 1) * img_width);
      }
    }
  
    slideImages();
  }
  
  function createDraggingEffects(e) {
  
    mouse_position_x[1] = e.clientX;
  
    if (mouse_position_x[0] == mouse_position_x[1]) {
      return false;
    }

    let scrolled_distance = Math.abs((mouse_position_x[0] - mouse_position_x[1]));
    const weight = img_width / 12;
    
    if (mouse_position_x[0] > mouse_position_x[1]) {
        scrolled_distance = move_distance - scrolled_distance - weight;
    } else {
        scrolled_distance = move_distance + scrolled_distance + weight;
    }
  
    slideImages(scrolled_distance); 
  }
  
  function dragAndSlideImages() {
    if (mouse_position_x[0] == mouse_position_x[1]) {
      slideImages();
      return false;
    }

    if (Math.abs(mouse_position_x[0] - mouse_position_x[1]) < 30) {
      slideImages();
      return false;
    }

    if (mouse_position_x[0] > mouse_position_x[1]) {
      calculateNextDistance();
    } else {
      calculatePrevDistance();
    }
  }

  function init() {
    document.querySelector(`#dot-${current_index}`).classList.remove('is-active');
  
    img_width = document.querySelector('.main-wide-slider').clientWidth;
    imgs.forEach(img => img.style.width = `${img_width}px`);
    imgs_container.style.width = `${img_width * total_imgs}px`;
  
    current_index = total_imgs;
    calculateNextDistance();
  }
  
  init();
  
  next_btn.addEventListener('click', calculateNextDistance);
  prev_btn.addEventListener('click', calculatePrevDistance);
  dots_container.addEventListener('click', slideDotImages);
  window.addEventListener('resize', init);
  
  
  arrow_dot_container.addEventListener('mousedown', (e) => {
    mouse_is_down = true;
  
    clearInterval(timer);

    mouse_position_x = [e.clientX, 0];
    arrow_dot_container.style.cursor = '-webkit-grabbing';
    console.log(mouse_position_x);
  })
  
  arrow_dot_container.addEventListener('mousemove', (e) => {
    if (!mouse_is_down) return false; 
    createDraggingEffects(e);
  })
  
  arrow_dot_container.addEventListener('mouseup', (e) => {
    mouse_position_x[1] = e.clientX;
    dragAndSlideImages(e);
    mouse_is_down = false;
    arrow_dot_container.style.cursor = '';
  
    console.log(current_index);
  })
  
  arrow_dot_container.addEventListener('mouseleave', () => {
    if (!mouse_is_down) return false;
    
    mouse_position_x = [0, 0];
    dragAndSlideImages();
    mouse_is_down = false;
    arrow_dot_container.style.cursor = ''; 
  })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-components-presentation"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {

  const ledSwitchCheckbox = document.querySelector('.rocker input[type="checkbox"]');
  
  const sakuraOrigin = document.getElementById("sakura-origin");
  const sakuraRgb = document.getElementById("sakura-rgb");
  
  ledSwitchCheckbox.addEventListener('change', function() {
    if (this.checked) {
      sakuraOrigin.style.display = "none";
      sakuraRgb.style.display = "inline";
    } else {
      sakuraOrigin.style.display = "inline";
      sakuraRgb.style.display = "none";
    }
  });

  const overlayHeaders = document.querySelectorAll('.pc-components-overlays h3');
  const recommendItemContainers = document.querySelectorAll('.pc-components-recommend-item-container');
  
  overlayHeaders.forEach(header => {
    header.addEventListener('click', function() {
      const overlayId = this.closest('.pc-components-overlays').id;
      const targetRecommendId = overlayId.replace('overlay', 'recommend');
      const targetRecommendContainer = document.getElementById(targetRecommendId);
      
      recommendItemContainers.forEach(container => {
        container.style.display = 'none';
      });
      
      if (targetRecommendContainer) {
        targetRecommendContainer.style.display = 'block';
      }
      
      const allImages = document.querySelectorAll('#aio-cover-overlay img, #rear-case-panel-overlay img, #fan-grill-overlay img, #support-bracket-overlay img, #bottom-case-panel-overlay img, #backplate-overlay img');
      allImages.forEach(img => {
        img.style.filter = 'invert(1)';
      });

      const targetImg = document.querySelector(`#${overlayId} img`);
      if (targetImg) {
        targetImg.style.filter = 'invert(0)';
      }
      
    });
  });
  
  const textCircle = document.querySelector(".led-frame-circle-text");
  textCircle.innerHTML = textCircle.innerText
    .split("")
    .map(
      (char, i) => `<span style="transform:rotate(${i * 7.8}deg)">${char}</span>`
    )
    .join("");
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-setup-view-section"] && !window.DesignMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function() {
        let slider = document.querySelector(".setup-view-slider");
        let overlay = document.querySelector(".setup-view-slider-overlay");
        let links = document.querySelectorAll(".setup-view-link");
        let slidebars = document.querySelectorAll(".setup-view-product-window");
    
        // Hide all slidebars initially
        function hideAllSlidebars() {
            slidebars.forEach(function(slidebar) {
                slidebar.style.display = 'none';
            });
        }
        hideAllSlidebars();
    
        // Loop through each link and bind the appropriate action
        links.forEach(function(link, index) {
            link.addEventListener("click", function() {
                hideAllSlidebars(); // Ensure that previous slidebars are hidden
                slider.style.left = "0";
                overlay.style.visibility = "visible";
                overlay.style.opacity = "1";
    
                // Show the corresponding slidebar
                let slidebar = document.getElementById("sv-slidebar-" + (index + 1));
                if (slidebar) {
                    slidebar.style.display = 'block';
                }
            });
        });
    
        // Add click event to overlay to close the slider
        overlay.addEventListener("click", function() {
            slider.style.left = "-100%";
            overlay.style.visibility = "hidden";
            overlay.style.opacity = "0";
            hideAllSlidebars();
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vshojo-collabs-section"] && !window.DesignMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
    
        // Get all grid elements
        let grids = document.querySelectorAll('.vshojo-talents-grid[id^="talent-grid-"]');
        
        grids.forEach(function(grid) {
            grid.addEventListener('click', function() {
    
                // Extract the number from the grid ID
                let gridNum = this.id.split('-').pop();
    
                // Scroll to the associated tab content
                let associatedTab = document.getElementById('talent-tab-' + gridNum);
                if (associatedTab) {
                    associatedTab.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            });
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wallart-theme-collection"] && !window.DesignMode) return;
  try {
    
  const thumbnails = document.querySelectorAll('.theme-collection-background-thumbnails');

  const changeBackground = (id) => {
    const backgrounds = document.querySelectorAll('.theme-collection-background');
    backgrounds.forEach(bg => bg.style.display = 'none');
    
    const correspondingBackground = document.getElementById(`theme-background-${id}`);
    correspondingBackground.style.display = 'block';
  };

  thumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', function() {
      const thumbnailId = this.id.split('-').pop();  // Extract the last part of the id, which is the number
      changeBackground(thumbnailId);  // Change background
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["WISHLIST_HERO_BKP_header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["WISHLIST_HERO_BKP_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
